import { Component } from '@angular/core';
import { ModalController, NavController, NavParams, ViewController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BarcodeScanner } from "@ionic-native/barcode-scanner";
import { ApiService } from "../../services/api.service";
import { SearchPartPage } from "../search-part/search-part";

@Component({
  selector: 'page-report-add-repair',
  templateUrl: 'report-add-repair.html',
})
export class ReportAddRepairPage {

  items = [];
  form: FormGroup;

  datePickerOptions: any = {
    buttons: [{
      text: 'Leeg maken',
      handler: () => {
        this.form.controls['time_manufactured'].setValue(null);
      }
    }]
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public formBuilder: FormBuilder,
    public barcodeScanner: BarcodeScanner,
    public api: ApiService,
    public viewCtrl: ViewController
  ) {
    this.items = this.navParams.get('items');
    this.form = this.formBuilder.group({
      time_manufactured: [''],
      description: ['', Validators.required],
      code: [''],
      part_title: [''],
      part_ean: [''],
      remark: ['']
    });
  }

  searchPart(query){
    this.api.searchPart(query).then((data: any) => {
      if(data.length > 0){
        let record = data[0];
        record.part_title = record.title;
        record.part_ean = record.ean;
        this.form.patchValue(record);
      }
    }).catch(() => {
      // do nothing
    });
  }

  openSearchPart(){
    this.modalCtrl.create(SearchPartPage, {
      page: this
    }).present();
  }

  setPart(record){
    this.form.patchValue(record);
  }

  save(){
    this.items.push(this.form.value);
    this.closeModal();
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportAddRepairPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-add-repair/report-add-repair.ts